/**
 * FontSelector - Dropdown for selecting fonts
 */
export const FontSelector = ({ value, onChange, fonts }) => {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="bg-black border border-white/10 text-white px-3 py-2 text-sm"
      data-testid="font-selector"
    >
      <option value="">Default Font</option>
      {fonts.map((font) => (
        <option key={font.id} value={font.family}>
          {font.name}
        </option>
      ))}
    </select>
  );
};

export default FontSelector;
